import PortfolioShareModal from '@/components/portfolio/PortfolioShareModal.vue';
import { mountVuePage } from '@/main';

type PortfolioShareModalController = {
    openForBook: (bookId: string) => void;
};

const MOUNT_NODE_ID = 'gh-portfolio-share-modal-root';

let isInstalled = false;

// 將 modal 掛在 body 層級，避免被會員區塊等隱藏容器影響顯示
const ensureMountSelector = (): string => {
    if (!document.getElementById(MOUNT_NODE_ID)) {
        const mountNode = document.createElement('div');
        mountNode.id = MOUNT_NODE_ID;
        document.body.appendChild(mountNode);
    }

    return '#' + MOUNT_NODE_ID;
};

/**
 * 掛載作品分享 modal 並對舊頁面公開開啟介面
 */
export const installPortfolioShareRuntime = async (): Promise<void> => {
    if (isInstalled) {
        return;
    }

    isInstalled = true;

    const appInstance = await mountVuePage({
        selector: ensureMountSelector(),
        appKey: 'portfolio-share-modal',
        render: (h) => h(PortfolioShareModal, { ref: 'shareModalRef' }),
    });

    if (!appInstance) {
        isInstalled = false;

        return;
    }

    const modalController = appInstance.$refs.shareModalRef as unknown as
        PortfolioShareModalController | undefined;

    window.GHPortfolioShare = {
        open: (bookId: string): void => {
            modalController?.openForBook(bookId);
        },
    };
};
